import {useRouteError} from 'react-router-dom';
import {
  ApplicationExpiredError,
  NotFoundError,
  SomeThingWentWrong,
} from '../components/ErrorElements';
import {useVisaRequest} from '@/query/hooks';
import {useEffect} from 'react';
import {captureException} from '@sentry/react';

const ErrorElement = () => {
  const request = useVisaRequest();
  const error = useRouteError() as Response;

  useEffect(() => {
    captureException(error);
  }, [error]);

  if (request?.is_invalid) {
    return (
      <ApplicationExpiredError
        code={request.application_code}
        to={request.new_application_url}
      />
    );
  } else if (error?.status === 404) {
    return <NotFoundError to={request.new_application_url} />;
  } else {
    return <SomeThingWentWrong to={request.new_application_url} />;
  }
};

export default ErrorElement;
